import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import { EqualHeightElement } from '../../../utils/components/EqualHeight';
const TitleWrapper = ({ children }) => (React.createElement(EqualHeightElement, { name: "UniCardTitle", inherit: true },
    React.createElement(Box, null, children)));
export default TitleWrapper;
